export default "__VITE_ASSET__BnZEES8i__"